import { EXTERNAL_OWNER_SYSTEMS } from '@/modules/file/constants'
import { isAllowed } from '@/modules/document/components/file-info/actions/helpers'
import { isReviewableInvoiceArt } from '@/modules/document/utils/document-invoice-kind'
import { isRefreshableAnalysedInvoice } from '@/modules/document/utils/invoice-analysis-state'

export interface RefreshAnalysisCandidate {
  id?: string | number
  externalOwnerSystem?: unknown
  mimetype?: unknown
  type?: unknown
  tags?: unknown[]
  metaData?: {
    analysisInProgress?: boolean
    analysisDoneAt?: string | null
    freshAnalysisAt?: string | null
    ocr?: {
      isRunning?: boolean
    } | null
  } | null
  documentInvoiceDetails?: {
    reviewStatus?: string | null
  } | null
}

/**
 * The document-only half of the „Erneut analysieren" gate.
 *
 * Rights and the tenant feature flag belong to the host, because a review can be opened through
 * Documents, Expenses or Revenues. Everything tied to the selected file lives here so the drawer,
 * review pages and receipt details cannot disagree about Desktop files, unsupported MIME types,
 * document Art or the analysis lifecycle.
 */
export const isRefreshAnalysisDocumentEligible = (
  document?: RefreshAnalysisCandidate | null,
): document is RefreshAnalysisCandidate & { id: string | number } => !!document
  && document.id != null
  && document.externalOwnerSystem !== EXTERNAL_OWNER_SYSTEMS.desktop
  && isAllowed(document)
  && isReviewableInvoiceArt(document)
  && isRefreshableAnalysedInvoice(document)
